"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
const material_1 = require("@mui/material");
function PageHeader({ title, }) {
    return (react_1.default.createElement(style_1.StyledContainer, null,
        react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
            react_1.default.createElement(style_1.Title, { mt: "24px", mb: "30px", variant: "h1" }, title))));
}
exports.default = PageHeader;
